<template>
    <div>
        <div class="lg:hidden w-16 h-16 sticky top-0 flex items-center justify-center bg-gray-warm-100 hover:bg-gray-warm-300 text-gray-warm-600 hover:text-gray-warm-700 cursor-pointer border-r border-b border-gray-400 shadow z-40"
            @click="show_slider = ! show_slider"
        >
            <i class="fa fa-ellipsis-h text-xl"></i>
        </div>

        <div v-if="show_slider"
            class="fixed inset-0 z-50 bg-black bg-opacity-75"
            @click="show_slider = false"
        >
            <div class="absolute top-0 right-0 lg:hidden h-screen text-gray-warm-700 hover:text-white px-3 py-3 xs:px-5 xs:py-5 cursor-pointer m-1"
                @click="show_slider = false"
            >
                <i class="far fa-times-circle text-3xl"></i>
            </div>
        </div>

        <div class="flex items-start fixed lg:relative lg:sticky h-screen top-0 z-50 transform lg:translate-x-0 transition-transform ease-in-out duration-300 overflow-auto"
            :class="show_slider ? 'translate-x-0' : '-translate-x-full'"
        >
            <div class="flex-shrink-0 h-screen bg-gray-warm-75">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show_slider: false,
        }
    },
}
</script>
